import { useRenderNotifier } from '@wui/common-library'
import { useIM, ConferenceType } from '@wui/im'
import dayjs from 'dayjs'

import { useStoreRooms } from '@/entities/room'

import { useLocalization } from '@/shared/composables/localization'
import { UI_DATE_TIME_FORMAT } from '@/shared/utils/constants'
import { fromPServedUser } from '@/shared/utils/uri'

export const createAndStartFastConference = async (mode: ConferenceType): Promise<string | undefined> => {
  const { generateConferenceToken, createConference } = useIM()
  const { t } = useLocalization()
  const { createRoom } = useStoreRooms()

  const name = mode === ConferenceType.FREE_FOR_ALL ? t('calls.fastConference') : t('mainAside.moderatedConference')

  try {
    const roomToken = await generateConferenceToken()
    if (!roomToken) {
      throw new Error(t('common.errorWhileRequest'))
    }

    const { item } = await createConference({
      mode,
      name: `${name} ${dayjs().format(UI_DATE_TIME_FORMAT)}`,
      subscribers: [],
      token: roomToken,
    })

    const roomId = fromPServedUser(item.pServed)

    createRoom({
      id: roomId,
      pServedUser: item.pServed,
      name: item.name,
      isGroup: true,
      number: roomId,
      subscribers: new Map(),
      guests: new Map(),
      token: item.token!,
      isExternal: false,
    })

    return roomId
  } catch (e: unknown) {
    useRenderNotifier().notifyError(e instanceof Error ? e.message : t('common.unknownError'))
    return undefined
  }
}
